export default "__VITE_ASSET__BdPUrYA1__"